<template>
  <div>
    <u-select :items="types"
              item-text="text"
              item-value="value"
              :label="$t('components.questionnaires.panels.title.type')"
              :value="input.extra"
              @change="onEditControl('titleType', $event.toLowerCase())"
              color="valid"
    />
    <v-text-field :label="$t('components.questionnaires.panels.title.label')"
                  :value="input.value"
                  @change="onEditControl('value', $event)"
                  color="valid"
    />
  </div>
</template>

<script>
import panelMixin from '@/components/questionnaires/fields/editPanels/panelMixin'

export default {
  name: 'TitleEditPanel',
  mixins: [panelMixin],
  data () {
    return {
      input: {},
      types: [
        {
          text: this.$t('components.questionnaires.panels.title.h1'),
          value: 'main'
        },
        {
          text: this.$t('components.questionnaires.panels.title.h2'),
          value: 'secondary'
        }
      ]
    }
  },
  created () {
    this.input = this.control
  }
}
</script>
